import { createOperationDescriptor, createReaderSelector, ROOT_ID } from 'relay-runtime';

import fragment, {
	type useAgentSessionsData_query$data,
} from './__generated__/useAgentSessionsData_query.graphql';
import query from './__generated__/useAgentSessionsDataPaginationQuery.graphql';
import type { AgentSessionsLiveReader } from './agentSessionsLiveCoordinator';

/** Read handled connection edges now, including pages published before React effects run. */
export const isSessionInLoadedConnection = (
	reader: AgentSessionsLiveReader,
	sessionId: string | null | undefined,
): boolean => {
	if (sessionId == null) return false;
	const operation = createOperationDescriptor(query, reader.variables);
	const selector = createReaderSelector(fragment, ROOT_ID, reader.variables, operation.request);
	const data = reader.environment.lookup(selector).data as useAgentSessionsData_query$data;
	return data.agent_sessionQuery?.edges?.some((edge) => edge?.node?.id === sessionId) ?? false;
};
